import Vue from 'vue'
import VRouter from 'vue-router'

// 引入组件
import registerHome from "../components/registerHome.vue";
import registerEnterprise from "../components/registerEnterprise.vue";
import registerIndividual from "../components/registerIndividual.vue";
import info from "../components/info.vue";
import wallet from "../components/wallet.vue"
import order from "../components/order.vue"
import about from "../components/about.vue"
import member from "../components/merber.vue"
import search from "../components/search.vue"
import login from "../components/login.vue"
import forget from "../components/forget.vue"
import dzqm from "../components/dzqm.vue"
import uploadId from "../components/uploadId.vue"
import plateNumber from "../components/plateNumber.vue"
import error from "../components/error.vue"
import success from "../components/success.vue"
import openOrder from "../components/openOrder.vue"
import recharge from "../components/recharge.vue"
import report from "../components/report.vue"
import reportAll from "../components/reportAll.vue"

// 要告诉 vue 使用 vueRouter
Vue.use(VRouter);

const router = new VRouter({ 
	mode : 'history',
	base: '/wx',
	routes:[
		{
			path:'/',
			component: info
		},
		{
			path:'/report',
			component: report
		},
		{
			path:'/plateNumber',
			component: plateNumber
		},
		{
			path:'/dzqm',
			component: dzqm
		},
		{
			path:'/reportAll',
			component: reportAll
		},
		{
			path:'/openOrder',
			component: openOrder
		},
		{
			path:'/forget',
			component: forget
		},
		{
			path:'/search',
			component:search
		},
		{
			path:'/registerHome',
			component: registerHome
		},
		{
			path:'/registerEnterprise',
			component: registerEnterprise
		},
		{
			path:'/registerIndividual',
			component: registerIndividual
		},
		{
			path:'/info',
			component: info
		},
		{
			path:'/wallet',
			component: wallet
		},
		{
			path:'/order',
			component: order
		},
		{
			path:'/about',
			component: about
		},
		{
			path:'/member',
			component: member
		},
		{
			path:'/uploadId',
			component: uploadId
		},
		{
			path:'/error',
			component: error
		},
		{
			path:'/success',
			component: success
		},{
			path:'/recharge',
			component: recharge
		},
	]
})

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
	next()
  //拦截的页面
  if(to.path === '/order' || to.path === '/wallet'){
    if (localStorage.getItem("status") == 4) {
      next()
    }else{
	  next("/error?text=您还没有完成认证，暂无该权限")
	}
  } else{
	  next()
  }
  
});

export default router

